module.exports = "/pages/google/Common/Hotelslabo/Simple/first_view_background.jpg";